var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#004EA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 6.16669C7.59579 6.16669 5.09179 9.49091 4.12886 11.1205C3.90546 11.4985 3.79377 11.6875 3.80562 11.9824C3.81747 12.2773 3.94773 12.462 4.20826 12.8316C5.3442 14.4428 8.18741 17.8334 11.9993 17.8334C15.8113 17.8334 18.6545 14.4428 19.7904 12.8316C20.051 12.462 20.1812 12.2773 20.1931 11.9824C20.2049 11.6875 20.0932 11.4985 19.8698 11.1205C18.9069 9.49091 16.4029 6.16669 11.9993 6.16669Z",
    stroke: "#F6F7F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.5,
    stroke: "#F6F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLight);
export default __webpack_public_path__ + "static/media/EyeLight.86a0f1d330cd0e3fe65b85ca546a3fc1.svg";
export { ForwardRef as ReactComponent };